/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(window).load(function() {
  $('.flexslider').flexslider({
    animation: "slide"
  });
});
